import styled from "styled-components";
import type {
  InterstateOnChangeEvent,
  TextInputEventValue
} from "@dealer-center/core-components";
import {
  Button,
  FunnelIcon,
  InformationCircleIcon,
  Popover,
  TextInput
} from "@dealer-center/core-components";
import { useContext, useEffect, useState } from "react";
import { searchByAccountLabelText } from "../../consts";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
export interface AccountSearchViewInterface {
  setShowFilters?: (newValue: boolean) => void;
}

interface StyledTextInputInterface {
  showFilters: boolean;
}

const StyledTextInput = styled(TextInput)<StyledTextInputInterface>`
  flex-grow: 0.5;
  margin-top: ${props => (props.showFilters ? "0" : "24px")};
  @media (max-width: 768px) {
    flex-grow: 1;
  }
`;
const StyledTooltip = styled(Popover)``;
const StyledSearchTipsButton = styled(Button)`
  display: flex;
  align-items: center;
  margin-left: 5px;
  padding: 0;
  padding-right: 4px;
  margin-bottom: 12px;
  svg {
    margin-right: 5px;
  }
`;
const StyledNamesFilterArea = styled.div`
  display: flex;
`;
const stripAsterisks = (text: string | undefined | number) =>
  text?.toString().replace(/^\*|\*$/g, "");

export const AccountSearchViewTop = ({
  setShowFilters
}: AccountSearchViewInterface) => {
  const { updateSearchRequest, searchRequest } =
    useContext(AccountSearchContext);
  const [basicTextFilter, setBasicTestFilter] = useState<
    string | undefined | number
  >(searchRequest.ids?.[0] || "");

  const StyledTextInputOnChange = (
    e: InterstateOnChangeEvent<TextInputEventValue>
  ) => {
    const textValue = e.target.value;
    const textValueWithoutAsterisks = stripAsterisks(textValue);
    const textValueWithAsterisks = `*${textValueWithoutAsterisks}*`;

    setBasicTestFilter(textValueWithoutAsterisks);
    if ((textValueWithoutAsterisks?.length || 0) > 2) {
      updateSearchRequest({
        ...searchRequest,
        ids: [textValueWithAsterisks]
      });
    }
  };

  // if the result has changed, update the basic text filter
  useEffect(() => {
    const textValue = searchRequest.ids?.[0] || "";
    const textValueWithoutAsterisks = stripAsterisks(textValue);
    setBasicTestFilter(textValueWithoutAsterisks);
  }, [searchRequest]);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      window.open(
        `/welcome/as/${basicTextFilter}/${basicTextFilter}-admin/`,
        "_blank"
      );
    }
  };
  const tipContent = (
    <div>
      <p>Pro-Search Tips</p>
      <p>abc* = Starts with "abc"</p>
      <p>*abc = Ends with "abc"</p>
      <p>*abc* = Contains "abc"</p>
    </div>
  );
  return (
    <StyledNamesFilterArea>
      {setShowFilters && (
        <Button
          analyticsConfiguration={{
            eventName: "Client Search Advanced Filters Clicked"
          }}
          buttonStyle="secondary"
          data-testid="advanced-filters-button"
          icon={<FunnelIcon title="Advanced Filters" />}
          sx={{ marginRight: "4px", marginTop: "20px" }}
          onClick={() => setShowFilters(true)}
        />
      )}
      <StyledTextInput
        inputSuffix={
          <StyledTooltip
            padding={true}
            popoverContent={tipContent}
            position="left"
            trigger="outsideClick"
          >
            <StyledSearchTipsButton
              analyticsConfiguration={{
                eventName: "Client Search Search Tips Clicked"
              }}
              buttonStyle="aux"
              size="small"
            >
              <InformationCircleIcon title="Search Tips" /> Search Tips
            </StyledSearchTipsButton>
          </StyledTooltip>
        }
        label="."
        maxLength={50}
        name="name"
        placeholder={searchByAccountLabelText}
        showFilters={!!setShowFilters}
        sx={{ label: { visibility: "hidden" } }} // we want the label to be hidden, but still exist so it lines up with the other inputs
        value={basicTextFilter?.toString()}
        onChange={StyledTextInputOnChange}
        onKeyDown={onKeyDown}
      />
    </StyledNamesFilterArea>
  );
};
